const stepsByStatus: Record<string, number> = {
    queued: 0, processing: 0, requesting: 0, recovering: 0,
    identifying_foods: 1, calculating_nutrition: 2, finalising: 3,
    completed: 4, completed_background: 4, saved: 4, ready: 4,
};

export function manualAnalysisStep(status: string): number {
    return stepsByStatus[status] ?? 0;
}

export function updateManualAnalysisProgress(root: Element, status: string, message?: string): void {
    const panel = root.querySelector<HTMLElement>('[data-manual-analysis-progress]');
    if (!panel) return;
    if (root.getAttribute('data-analysis-progress-location') === 'queue') {
        panel.hidden = true;
        return;
    }
    const failed = ['failed', 'idle', 'superseded'].includes(status);
    const step = failed ? Number(panel.dataset.currentStep || 0) : manualAnalysisStep(status);
    const ready = !failed && step === 4;
    panel.hidden = false;
    panel.dataset.currentStep = String(step);
    panel.dataset.failed = String(failed);
    panel.querySelectorAll<HTMLElement>('[data-manual-progress-step]').forEach((item, index) => {
        const state = index < step || ready ? 'complete'
            : index === step ? (failed ? 'failed' : 'active') : 'pending';
        item.dataset.state = state;
        if (state === 'active') item.setAttribute('aria-current', 'step');
        else item.removeAttribute('aria-current');
        const accessibleState = item.querySelector('[data-manual-progress-state]');
        if (accessibleState) accessibleState.textContent = {
            complete: 'Completed', active: 'In progress', failed: 'Stopped', pending: 'Not started',
        }[state];
    });
    const count = panel.querySelector('[data-manual-progress-count]');
    if (count) count.textContent = failed ? 'Analysis stopped' : ready ? 'Complete' : `Step ${step + 1} of 5`;
    const description = panel.querySelector('[data-manual-progress-message]');
    const text = message || (failed ? 'The analysis could not be completed. Please try again.' : [
        'Preparing your meal details…',
        'Identifying ingredients, portions and preparation…',
        'Estimating nutrition for your ingredients…',
        'Preparing your results for review…',
        'Your analysis is ready to review.',
    ][step]);
    // Avoid repeating screen-reader announcements on every poll.
    if (description && description.textContent !== text) description.textContent = text;
}
